import { BaseError } from 'make-error'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const NAME = `PageError`
const MESSAGE = `Problem displaying page`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

class PageError extends BaseError {
  constructor(originalError) {
    super(MESSAGE)
    this.name = NAME
    this.originalError = originalError
  }
}

export default PageError
